<template>
  <span class="font-size-075-rem text-color-light-gray">©2021 Kids Public</span>
</template>
